export default __webpack_public_path__ + "media/images/home/living_booking-de6bfe611b019bec76042dc1ecbf1bc8.webp";